import { render, staticRenderFns } from "./DeletePolicyDialog.vue?vue&type=template&id=720ec995"
import script from "./DeletePolicyDialog.vue?vue&type=script&lang=js"
export * from "./DeletePolicyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports